export class FileConstants {
  static FILE_MAX_SIZE = 2000000;
  public static UPLOAD_BULK_USERS_FILE_TYPE = [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    '.csv',
    'text/csv',
  ];
  public static UPLOAD_ORDERS_FILE_TYPE = [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  public static fileSizes = [' Bytes', ' KB', ' MB', ' GB', ' TB', ' PB', ' EB', ' ZB', ' YB'];
  public static COMMERCIAL_FILE_NAME = 'CR';
  static  MAX_FILE_SIZE = 10 * 1024 * 1024;
  static COMMERCIAL_FILE_SIZE = 2 * 1024 * 1024;
  public static UPLOAD_IMAGE_MAX_SIZE_HINT = '5MB';
  public static UPLOAD_IMAGE_MAX_SIZE_KB = 5242880;
  public static UPLOAD_IMAGE_COUNT_LIMIT = 10;

}
